import React from 'react';
import {
  EPersonaViewMode,
  EPersonaIntegrationMode,
  tavusPersonaStore
} from 'entities/tavus/persona';
import SelectInput from 'components/shared/SelectInput';
import { Tabs } from 'shared/ui';
import { useLocation } from 'react-router';
import { AVATARS_CREATE_PERSONA_ROUTE } from 'shared/model';

const PREVIEW_MODE_OPTIONS = [
  { label: 'Before call', value: EPersonaViewMode.BEFORE_CALL },
  { label: 'On call', value: EPersonaViewMode.ON_CALL },
  { label: 'Post call', value: EPersonaViewMode.POST_CALL }
];

const TABS: EPersonaIntegrationMode[] = [
  EPersonaIntegrationMode.EMBED,
  EPersonaIntegrationMode.WIDGET
];

const PreviewToolMenu: React.FC = () => {
  const {
    personaViewMode,
    setPersonaViewMode,
    personaIntegrationViewMode,
    setPersonaIntegrationViewMode
  } = tavusPersonaStore();
  const { pathname } = useLocation();

  const selected = PREVIEW_MODE_OPTIONS.find(
    (o) => o.value === personaViewMode
  )!;

  React.useEffect(() => {
    if (pathname.includes(AVATARS_CREATE_PERSONA_ROUTE)) {
      setPersonaViewMode(EPersonaViewMode.ON_CALL);
    }
  }, [pathname]);

  return (
    <div className="ag-w-full ag-flex ag-flex-row ag-justify-between ag-items-end ag-relative">
      {!pathname.includes('video-agents/avatars/create') && (
        <>
          <Tabs
            className="ag-w-full"
            tabs={TABS}
            activeTab={personaIntegrationViewMode}
            setActiveTab={setPersonaIntegrationViewMode}
          />
          <div className="ag-absolute ag-right-0">
            <SelectInput
              name="persona-view-mode"
              options={PREVIEW_MODE_OPTIONS.map((o) => o.label)}
              value={selected.label}
              onChange={(label) => {
                const selectedOption = PREVIEW_MODE_OPTIONS.find(
                  (o) => o.label === label
                );
                if (selectedOption) {
                  setPersonaViewMode(selectedOption.value);
                }
              }}
              onRightSide
              className="!ag-bg-white !ag-text-dark-purple !ag-z-10 ag-border-none ag-rounded-[10px] !ag-shadow-none -ag-translate-y-2 !ag-w-auto !ag-py-[0.2em]"
              wrapperClassName="!ag-w-auto"
              cheronNearText
              optionsWrapperClassName="ag-bg-white"
              optionsClassName="ag-text-sm ag-text-neutral-800 hover:ag-bg-neutral-100"
              activeClassName="ag-bg-neutral-100"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewToolMenu;
